module.exports = __webpack_public_path__ + "img/4.dcb0b652.png";